/**
 * One way to write a date across the web app (until 2026-10-28 /proves wrote «27 d’oct. del 2026», the inspections
 * «19/10/2026 7:56:58» and the reports «28/10/2026 3:55:51»). A moment is the day and the hour to the minute, a day
 * is the day alone; pages that need another shape (a full weekday, the hour alone) keep their own.
 */
const MOMENT = new Intl.DateTimeFormat('ca', { dateStyle: 'medium', timeStyle: 'short' });
const DAY = new Intl.DateTimeFormat('ca', { dateStyle: 'medium' });

/** «28 d’oct. 2026, 3:55». */
export const fmtMoment = (iso: string): string => MOMENT.format(new Date(iso));

/** «28 d’oct. 2026». */
export const fmtDay = (iso: string): string => DAY.format(new Date(iso));
